module.exports = global.fileCache = {
  mainPlaylistCache: [],
  secondaryPlaylistCache: [],
};
